export const mutationObserver = (targetNode) => {
  const config = { attributeFilter: ["aria-hidden"] };
  const callback = function(mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.target.getAttribute("aria-hidden") === "true") {
        mutation.target.setAttribute("aria-hidden", "false");
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
};
